import { Component, OnInit, ViewChild, ElementRef, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, ReactiveFormsModule, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../../../data.service';
import{ UrlConstant } from '../../../constants/url-constant';
import{ GlobalConstant } from '../../../constants/global-constant';
import{ AppData } from '../../../constants/app-data';

@Component({
  selector: 'app-test-series',
  templateUrl: './test-series.component.html',
  styleUrls: ['./test-series.component.css']
})
export class TestSeriesComponent implements  OnInit {
  public token;
  public testSeriesUrl;
  public testSeriesSanUrl;
  safeSrc: SafeResourceUrl;
  
  constructor(private router: Router, private routeParams: ActivatedRoute, 
  				private fb: FormBuilder, private sanitized: DomSanitizer, 
  				private dataService: DataService, private appData: AppData) {
  	//dataService.getApiKeyHeaderFromLocalStorage();
  	//var headers = new HttpHeaders().set(this.appData.keyApiKeyHeader, dataService.getApiKeyHeaderFromLocalStorage());
  	
  	this.token = dataService.getApiKeyHeaderFromLocalStorage();
  	if(this.token === undefined || this.token === '' || this.token === null){
  		this.dataService.navigateToUrl('/home');
  	}
  	
  	//waits for the call response
  	//(async () => {
	  //  this.testSeriesUrl = await dataService.getStaticData({});
	//  });
  	let page = this.routeParams.snapshot.params['p'];
  	let user = this.routeParams.snapshot.params['u'];
  	
  	let testSeriesUrl =  this.dataService.getFromLocalStorage(GlobalConstant.KEY_TEST_SERIES_URL_ENC);// + '?t=' + this.token ;
  	testSeriesUrl = this.dataService.decryptUsingAES256(testSeriesUrl, null);
  	
  	if(testSeriesUrl === ''){
  		this.dataService.navigateToUrl('/login');
  	}
  	
  	if(page == undefined || page === 'i')
  		this.testSeriesUrl = testSeriesUrl+ 'init.test' + '?t=' + this.token ;
  	else
  		this.testSeriesUrl = testSeriesUrl+ 'testReportOthersPage.test' + '?t=' + this.token + '&u=' + user;
  		
  	console.log('localstorage testSeriesUrl: '+ this.testSeriesUrl);
  	
  	// this.testSeriesUrl = 'http://localhost:8089/init.test?t=' + this.token ;
  	// this.testSeriesUrl = 'http://skillsmira.com/test-series/init.test?t=' + this.token ;
  	//this.testSeriesUrl = 'http://103.154.233.106:80/test-series/init.test?t=' + this.token;
  	console.log('test-series contructor');
  	this.safeSrc = this.transform(this.testSeriesUrl);
  }
  	@ViewChild('muIframe') muIframe: ElementRef;
  	
	ngOnInit(): void {
		//this.getData();
		this.dataService.getApiKeyHeaderFromLocalStorage();
	}
	
	transform(value) {
        return this.sanitized.bypassSecurityTrustResourceUrl(value);
    }
    
    callFormSubmit(){
    	console.log('hi');
    	 let form: HTMLFormElement = <HTMLFormElement>document.getElementById('f1');
         form.submit();
                
                
    	 //let el: HTMLElement = this.f1.nativeElement;
    	 //let el = document.getElementById('f1') as HTMLElement;
    	// el.submit();
    	//this.b1.click();
    	//document.getElementById("b1").click();
    }
    
    private getIframeURL(url) {
        //return this.sanitized.bypassSecurityTrustResourceUrl('http://localhost:8089/init.test');
        return this.sanitized.bypassSecurityTrustResourceUrl(url);
    }
    
    getData(){
    	this.dataService.sendGetRequestWithBlobResponse(UrlConstant.htmlTestSeriesInitPage, 'html').subscribe((res: any)=>{
	      console.log(res);
	      //this.muIframe.baseURI ="http://localhost:8089/";
	      console.log(this.muIframe);
	      
	      //this.muIframe.nativeElement.src = res; 
	      //this.muIframe.wrrite( res);
	      
	      //URL.createObjectURL(m.blob());
	      //this.records = res.data;
	    });
	}
	
  	//this.dataService.sendGetRequestWithTextResponse("http://localhost:8089/init.test").subscribe((res: any)=>{
	  //    console.log(res);
	      //this.records = res.data;
	    //});
  //}
	//$scope.trustSrc = $sce.trustAsResourceUrl;
}
